import { alpha, Avatar, Grid2, IconButton, Typography } from "@mui/material";
import { IManager, IUser } from "sierra";
import Container from "../Container";
import ConfirmDialog from "../ConfirmDialog";
import { useState } from "react";
import api from "../../utils/axios";
import { useApp } from "../../contexts/AppContext";
import { Block, Close, Delete, Replay, Restore } from "@mui/icons-material";
import { useAuth } from "../../hooks/useAuth";

export default function UserCard({ user, manager, hideActions = false, onRefresh }: { user: IUser, manager?: Required<IManager>, hideActions?: boolean, onRefresh?: () => void }) {
    const { user: currUser } = useAuth()
    const { translate } = useApp()
    const [openDelete, setOpenDelete] = useState(false)
    const [openToggleDisable, setOpenToggleDisable] = useState(false)

    const disableToggle = manager && !manager.employees.includes(user.user_id);

    const handleDeleteUser = () => {
        api.delete('/users/' + user.user_id, { meta: { showSnackbar: true } }).then(onRefresh).catch(console.error)
    }

    const handleToggleDisable = () => {
        api.patch(`/users/${user.user_id}/isDisabled`, { is_disabled: !user.is_disabled }, { meta: { showSnackbar: true } }).then(onRefresh).catch(console.error)
    }

    return (
        <Container>
            <Grid2 container padding={2} alignItems={'center'} gap={2} justifyContent={'space-between'}>
                <Grid2 container gap={2}>
                    <Grid2>
                        <Avatar />
                    </Grid2>
                    <Grid2 container flexDirection={'row'} gap={2} alignItems={'center'}>
                        <Grid2 >
                            <Typography variant="h6" fontWeight={'bold'}>
                                {user.name} (#{user.user_id})
                            </Typography>
                        </Grid2>
                        <Grid2>
                            <Typography variant="caption">
                                {user.email}
                            </Typography>
                        </Grid2>
                    </Grid2>
                </Grid2>
                {
                    currUser &&
                    <Grid2 container gap={1} display={hideActions ? 'none' : 'flex'}>
                        <Grid2 display={
                            ['admin', 'manager'].includes(currUser.role) ? 'flex' : 'none'}>
                            <ConfirmDialog
                                title={translate(user.is_disabled ? 'Account Revoke' : 'Account Disable')}
                                text={translate(`Are you sure you want to ${user.is_disabled ? 'revoke' : 'disable'} this user account?`)}
                                open={openToggleDisable}
                                setOpen={setOpenToggleDisable}
                                onConfirm={() => {
                                    handleToggleDisable()
                                    setOpenToggleDisable(false)
                                }}>
                                <IconButton disabled={disableToggle} color={user.is_disabled ? "info" : "warning"} sx={{ backgroundColor: (t) => alpha(user.is_disabled ? t.palette.info.light : t.palette.warning.light, 0.2), border: disableToggle ? '1px solid grey' : user.is_disabled ? '1px solid blue' : '1px solid orange' }} onClick={() => setOpenToggleDisable(true)}>
                                    {user.is_disabled ? <Replay fontSize="small" /> : <Block fontSize="small" />}
                                </IconButton>
                            </ConfirmDialog>
                        </Grid2>
                        <Grid2 display={currUser.role === 'admin' ? 'flex' : 'none'}>
                            <ConfirmDialog
                                title={translate('User Delete')}
                                text={translate('Are you sure you want to delete this user?')}
                                open={openDelete}
                                setOpen={setOpenDelete}
                                onConfirm={() => {
                                    handleDeleteUser()
                                    setOpenDelete(false)
                                }}>
                                <IconButton color="error" sx={{ backgroundColor: 'rgba(255, 0, 0, 0.1)', border: '1px solid red' }} onClick={() => setOpenDelete(true)}>
                                    <Delete fontSize="small" />
                                </IconButton>
                            </ConfirmDialog>
                        </Grid2>
                    </Grid2>
                }
            </Grid2>
        </Container >
    )
}